import { render, staticRenderFns } from "./ClaimDates.vue?vue&type=template&id=75adda40&scoped=true"
import script from "./ClaimDates.vue?vue&type=script&lang=js"
export * from "./ClaimDates.vue?vue&type=script&lang=js"
import style0 from "./ClaimDates.vue?vue&type=style&index=0&id=75adda40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75adda40",
  null
  
)

export default component.exports